import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/**
 * BetaSpotsCounter - Now displays static "PRIVATE ACCESS • MEMBERSHIP" message
 * Beta is officially closed - no need to fetch status anymore
 */
const BetaSpotsCounter = ({ variant = 'default', showBenefits = false }) => {
  const { i18n } = useTranslation();

  const messages = {
    fr: {
      privateAccess: "ACCÈS PRIVÉ",
      membership: "MEMBERSHIP"
    },
    en: {
      privateAccess: "PRIVATE ACCESS",
      membership: "MEMBERSHIP"
    },
    pt: {
      privateAccess: "ACESSO PRIVADO",
      membership: "MEMBERSHIP"
    }
  };

  const lang = i18n.language?.substring(0, 2) || 'fr';
  const content = messages[lang] || messages.fr;
  
  // Minimal variant (for header/nav)
  if (variant === 'minimal') {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="flex items-center gap-2 text-sm"
        data-testid="membership-badge-minimal"
      >
        <Sparkles className="text-[#D4AF37]" size={14} />
        <span className="text-[#D4AF37] tracking-[0.15em] text-xs">
          {content.privateAccess} • {content.membership}
        </span>
      </motion.div>
    );
  }

  // Default variant
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-[#0A0A0A] border border-[#D4AF37]/30 p-6"
      data-testid="membership-badge"
    >
      {/* Header */}
      <div className="flex items-center justify-center gap-3 mb-4">
        <Sparkles className="text-[#D4AF37]" size={18} />
        <span className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase">
          {content.privateAccess} • {content.membership}
        </span>
        <Sparkles className="text-[#D4AF37]" size={18} />
      </div>

      {/* Founding Visionary info (if showBenefits) */}
      {showBenefits && (
        <div className="text-center">
          <p className="text-[#A1A1AA] text-sm leading-relaxed">
            Rejoignez une communauté exclusive de femmes entrepreneures
          </p>
        </div>
      )}
    </motion.div>
  );
};

export default BetaSpotsCounter;
